import { useEffect, useState } from 'react';
import './App.css';
import LoginForm from './components/auth/LoginForm';
import ChecklistForm from './components/checklist/ChecklistForm';
import AuthLayout from './layout/AuthLayout';
import DashboardLayout from './layout/DashboardLayout';
import { createChecklist, login, logout } from './services/api';

const USER_STORAGE_KEY = 'applyheating_user';

function App() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [authError, setAuthError] = useState('');
  const [formError, setFormError] = useState('');
  const [formSuccess, setFormSuccess] = useState('');

  useEffect(() => {
    const storedUser = localStorage.getItem(USER_STORAGE_KEY);
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        localStorage.removeItem(USER_STORAGE_KEY);
      }
    }
  }, []);

  const handleLogin = async (identity, password) => {
    setAuthLoading(true);
    setAuthError('');

    try {
      const response = await login(identity, password);
      const loggedInUser = response.user || {
        username: identity,
        name: identity,
        level: 'editor'
      };
      setUser(loggedInUser);
      localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(loggedInUser));
    } catch (error) {
      setAuthError(error.message || 'Login failed.');
    } finally {
      setAuthLoading(false);
    }
  };

  const handleLogout = async (event) => {
    event.preventDefault();
    try {
      await logout();
    } catch (error) {
      // Keep logout resilient even if backend session already expired.
    }
    setUser(null);
    setFormSuccess('');
    setFormError('');
    localStorage.removeItem(USER_STORAGE_KEY);
  };

  const handleChecklistSubmit = async (payload) => {
    setFormLoading(true);
    setFormError('');
    setFormSuccess('');

    try {
      await createChecklist(payload);
      setFormSuccess('Checklist saved successfully.');
    } catch (error) {
      setFormError(error.message || 'Failed to save checklist.');
    } finally {
      setFormLoading(false);
    }
  };

  if (!user) {
    return (
      <AuthLayout>
        <LoginForm onSubmit={handleLogin} loading={authLoading} error={authError} />
      </AuthLayout>
    );
  }

  return (
    <DashboardLayout user={user} onLogout={handleLogout}>
      <ChecklistForm
        onSubmit={handleChecklistSubmit}
        loading={formLoading}
        error={formError}
        success={formSuccess}
      />
    </DashboardLayout>
  );
}

export default App;
